<template>
  <div class="requirement-analysis">
    <div class="side-menu-box" ref="fixTopComponent">
      <div class="menuFixed">
        <div class="side-menu">
          <a
            class="menu-item flex items-center"
            :class="{
              active: item.id === menuCurrent,
            }"
            v-for="item in menuList"
            :key="item.id"
            @click="changeMenu($event, item.id)"
          >
            <span>{{ item.label }}</span>
          </a>
        </div>
        <div class="addNew" @click="handleBack"><i class="el-icon-plus" style="font-size: 14px"></i>创建新对话</div>
      </div>
    </div>
    <div class="menu-content relative">
      <div class="flex items-center justify-end export-pdf-box" style="height: 36px;">
        <el-button type="text" class="export-pdf" :disabled="status !== 'SUCCESS'" :loading="pdfLoading" @click="exportPdf">导出PDF</el-button>
      </div>
      <div class="scroll-content" ref="requirementContainer" @scroll="watchScroll">
        <!-- 思考过程 -->
        <div class="think-content">
          <toggle-component :default-visible="true" style="margin-bottom: 10px" ref="toggleRef2">
            <div class="markdown-body" v-html="thinkingMd"></div>
          </toggle-component>
          <p class="load-text" v-if="thinkLoading"><i class="el-icon-loading"></i></p>
        </div>
        <!-- 流式报告 -->
        <div v-if="reportLoading">
          <div class="content-bg" style="margin-bottom: 0">
            <p>正在生成报告</p>
            <p class="markdown-body" v-html="reporterMd" v-if="reporterMd"></p>
            <p class="load-text" v-if="reportLoading"><i class="el-icon-loading"></i></p>
          </div>
        </div>
        <!-- 报告内容 -->
        <div class="list-container" style="margin-top: 20px" v-show="!isStreaming && requirementData">
          <div :id="item.id" v-for="(item,i) in menuList" :key="i" class="list-item">
            <div class="flex">
              <img width="28" height="18" :src="titleLeft" style="margin-right: 5px" alt="">
              <div class="title-bg">
                <div class="flex justify-center" style="padding: 0 6px">{{item.label}}</div>
                <div class="title-bottom"></div>
              </div>
            </div>
            <div class="content-bg" v-loading="loadingData">
              <el-empty :image-size="140" v-if="!requirementData[item.label]" />
              <div v-else>
                <p class="markdown-body " v-html="requirementData[item.label]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-left: 13px">
      <div class="flex">
        <img width="28" height="18" :src="titleLeft" style="margin-right: 5px">
        <div class="title-bg">
          <div class="flex justify-center" style="padding: 0 6px">相关文献</div>
          <div class="title-bottom"></div>
        </div>
      </div>
      <div class="correlation">
        <div class="flex" style="padding: 17px 20px 0">
          <div @click="activeCo(item)" :class="activeCorrelation === item?'correlation-item-click':'correlation-item'"
               v-for="(item,i) in correlationTitleList" :key="i">
            {{ item }}
          </div>
        </div>
        <div ref="scrollContainer" style="max-height: calc(100vh - 130px);overflow-y: auto;">
          <person-list :person-data="achievementData.scholar" :talent-loading="achievementLoading" v-if="activeCorrelation === '专家'" />
          <org-list :org-data="achievementData.org" :talent-loading="achievementLoading" v-if="activeCorrelation === '机构'" />
          <paper-list :ach-data="achievementData.paper" :talent-loading="achievementLoading" v-if="activeCorrelation === '论文'" />
          <patent-list :ach-data="achievementData.patent" :talent-loading="achievementLoading" v-if="activeCorrelation === '专利'" />
          <project-list :ach-data="achievementData.project" :talent-loading="achievementLoading" v-if="activeCorrelation === '项目'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleLeft from '@/assets/images/GuoJiao/detail-title-left-icon.png';
import PersonList from '@/views/requirementAnalysis/comps/personList.vue';
import OrgList from '@/views/requirementAnalysis/comps/orgList.vue';
import PaperList from '@/views/requirementAnalysis/comps/paperList.vue';
import PatentList from '@/views/requirementAnalysis/comps/patentList.vue';
import ProjectList from '@/views/requirementAnalysis/comps/projectList.vue';
import ToggleComponent from '@/components/ToggleComponent.vue';
import { requirementDetailsMixin } from '@/mixin/requirementAnalysis/requirementMixin';

export default {
  mixins: [ requirementDetailsMixin ],
  name: 'requirementDetailsGuoJiao',
  components: { ProjectList, PatentList, PaperList, OrgList, PersonList, ToggleComponent },
  props: {},
  data () {
    return {
      titleLeft
    }
  },
  created() {
    document.title = '需求分析详情';
  },
  methods: {},
};
</script>

<style scoped lang="less">
.requirement-analysis {
  width: 100%;
  min-height: calc(100vh - 20px); // calc(100vh - 62px)
  max-height: calc(100vh - 20px); // calc(100vh - 62px)
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  padding-top: 20px;
  background: #F6F8FD;
  //background: linear-gradient(60.33deg, rgba(207, 234, 255, 0.4) 9%, rgba(227, 227, 255, 0.4) 46%, rgba(192, 223, 255, 0.4) 88%);
  justify-content: center;

  //.menuFixed {
  //  position: fixed;
  //  top: 100px;
  //  z-index: 9;
  //}

  .side-menu-box {
    width: 180px;
    margin-right: 12px;

    .side-menu {
      width: 180px;
      padding: 12px 0;
      border-radius: 16px;
      overflow: hidden;
      background: url("~@/assets/images/common/menu-bg.png");
      background-size: 100% 100%;
      opacity: .9;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);

      .menu-item {
        text-align: left;
        padding: 14px 0 14px 23px;
        user-select: none;

        .icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 27px;
          height: 22px;
          margin-right: 10px;

          img {
            object-fit: contain;
          }
        }

        span {
          color: #181F33;
          font-size: 14px;
        }
      }

      .active {
        position: relative;

        &:before {
          position: absolute;
          left: 1px;
          content: "";
          width: 4px;
          height: 16px;
          background: #3860F4;
        }

        span {
          font-weight: 500;
          color: #3860F4 !important;
        }
      }
    }

    .addNew {
      cursor: pointer;
      width: 180px;
      height: 44px;
      background-image: url("~@/assets/images/common/btn-bg.png");
      background-size: 100% 100%;
      border-radius: 8px;
      margin-top: 8px;
      display: flex;
      font-size: 14px;
      color: #3860F4;
      align-items: center;
      justify-content: center;
      opacity: .9;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);

      i {
        font-weight: bold;
        margin-right: 8px;
      }
    }
  }

  .title-bg {
    width: fit-content;
    font-weight: 500;
    font-size: 16px;
    color: #000000;

    .title-bottom {
      height: 6px;
      width: 100%;
      background: rgba(56, 96, 244, 0.3);
      border-radius: 3px;
      margin-top: -3px;
    }
  }

  .bottom-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 60px;
    right: 0;
    left: 0;
    margin: auto;
    color: #8b8b8b;
    cursor: pointer;
    background-color: #ffffff;
    z-index: 999;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.02),
    0 6px 10px 0 rgba(47, 53, 64, 0.1);

    &:hover {
      background-color: #f5f5f5;
    }

    i {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .menu-content {
    width: 835px;

    .list-container {
      .list-item {
        &:last-child {
          .content-bg {
            margin-bottom: 0 !important;
          }
        }
      }
    }

    .content-bg {
      width: 775px;
      margin-bottom: 30px;
      background: #FFFFFF;
      margin-top: 16px;
      padding: 24px 30px;
      border-radius: 8px;

      .content-title {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
      }

      .detail-content {
        margin-top: 20px;

        .content-left {
          font-size: 14px;
          min-width: 85px;
          line-height: 24px;
          color: #00000E65;
        }

        .content-right {
          font-size: 14px;
          line-height: 24px;
          color: #00000E85;
        }
      }
    ;

      .type-bg {
        background: #F2F5F9;
        border-radius: 8px;
        padding: 19px 15px;
      }

      .core-index {
        font-weight: 400;
        font-size: 16px;
        color: #464BFE;
      }

      .core-title {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 24px;
      }

      .core-content {
        margin-top: 13px;
        color: #00000E85;
      }

      .feasibility-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-bottom: 14px;
      }

      .feasibility-top {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 24px;
      }

      .feasibility-content {
        font-weight: 400;
        font-size: 14px;
        color: #00000E85;
        line-height: 24px;
      }

      .feasibility-left {
        font-weight: 400;
        font-size: 14px;
        display: flex;
        min-width: 80px;
        align-items: center;
        height: fit-content;
        color: #464BFE;
        line-height: 24px;
      }

      .feasibility-left-bg {
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #464BFE16;
        border-radius: 1px;
      }

      .feasibility-left-index {
        width: 4px;
        height: 4px;
        background: #464BFE;
        border-radius: 1px;
      }
    }

    .achievement-bg {
      width: 835px;
      min-height: 200px;
      margin-bottom: 30px;
      background: #FFFFFF;
      margin-top: 16px;
      padding: 31px 0 20px;
      border-radius: 8px;

      .achievement-item {
        margin-top: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #F2F5F9;
      }

      :first-child {
        margin-top: 0;
      }

      :last-child {
        border-bottom: none;
      }

      .achievement-title {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        padding: 0 30px;
        margin-bottom: 14px;

        .tips-item {
          background: #FFFFFF;
          border-radius: 2px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #464BFE85;
          height: 20px;
          padding: 0 7px;
          margin-left: 8px;
          border: 1px solid #464BFE85;
        }
      }

      .achievement-left {
        font-weight: 400;
        min-width: 80px;
        color: #00000E65;
        line-height: 24px;
      }

      .achievement-right {
        font-weight: 400;
        color: #00000E85;
        line-height: 24px;
      }

      .analysis-btn {
        margin-left: 30px;
        color: #464BFE85;
        margin-top: 13px;
        cursor: pointer;
      }

      .type-bg {
        background: #F2F5F9;
        border-radius: 8px;
        padding: 19px 15px;
        margin: 0 30px;
      }
    }

  }


  .scroll-content {
    height: calc(100vh - 76px); // calc(100vh - 156px)
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.correlation {
  width: 360px;
  margin-top: 16px;
  padding-bottom: 10px;
  background: #FFFFFF;
  border-radius: 8px;

  .correlation-item {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    width: 50px;
    height: 29px;
    background: #FFFFFF;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .correlation-item-click {
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    color: #3860F4;
    width: 50px;
    height: 29px;
    background: rgba(56, 96, 244, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.analysis-main {
  padding: 10px 20px;

  p {
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
  }
}

.think-content {
  padding: 20px 26px;
  background: #FFFFFF;
  border-radius: 8px;
  //margin-bottom: 20px;

  /deep/ .toggle-container {
    margin: 0 !important;
    .trigger {
      font-weight: 400 !important;
      color: #333333 !important;
      font-size: 16px !important;
      height: 30px !important;
      line-height: 30px !important;
    }
    .content {
      //margin-top: 8px !important;
    }
  }
}

.load-text {
  font-size: 14px;
  color: rgba(153, 153, 153, 0.9);
  line-height: 20px;
  padding: 4px 0 0;
  i {
    font-size: 18px !important;
    margin-right: 4px;
  }
}

.export-pdf-box {
  /deep/ .el-button {
    background: unset !important;
    &.is-loading:before {
      background: unset !important;
    }
    &.is-disabled, &.is-disabled:focus, &.is-disabled:hover {
      span {
        color: #C0C4CC !important;
      }
    }
  }
}

.export-pdf {
  width: 110px;
  height: 22px;
  line-height: 22px;
  //width: 180px;
  //height: 44px;
  //line-height: 44px;
  //color: #FFFFFF;
  //background: rgba(2, 38, 224, 0.7);
  font-size: 14px;
  color: #3860F4;
  padding: 0 !important;
  background: unset !important;
  border-radius: 8px;
  margin-bottom: 14px;
  border: none !important;
  user-select: none;
}

.markdown-body /deep/ .thinking-con p {
  margin: 0 !important;
}

.markdown-body {
  color: #181F33;
  /deep/ table {
    overflow-x: auto;
    thead {
      th {
        min-width: 90px !important;
        text-align: center !important;
      }
    }
    tbody {
      td {
        text-align: center !important;
      }
    }
  }
}
</style>
